<template>
  <div>
    <div class="cantSee">{{ reversedMessage }}</div>
    <div class="backgroundWhiteList mt-16">
      <b-container>
        <b-row>
          <div class="content">
            <div
              class="w-full bg-gray-800 rounded-[24px] flex flex-col gap-4 lg:flex-row justify-between px-8 py-6 md:px-12 md:py-10 mb-16 border-sky-500 border-4"
            >
              <span class="text-4xl text-white font-medium">Marketplace</span>
              <div class="flex flex-col">
                <div
                  class="flex justify-center bg-gray-900 rounded-[12px] text-lg md:text-2xl py-2 px-4 font-medium"
                >
                  <span class="text-purple-500 mr-2">
                    GASLESS CUT BALANCE:
                  </span>
                  <span class="text-white">{{ tokenAmount }}</span>
                </div>
                <a
                  href="/loadup"
                  class="rounded-[12px] text-lg md:text-2xl py-2 bg-purple-800 hover:bg-purple-900 mt-3 font-medium no-underline text-white flex items-center justify-center"
                  >Add Gasless CUT
                  <b-icon
                    icon="arrow-right"
                    class="text-white ml-3"
                    font-scale="1.5"
                  ></b-icon
                ></a>
              </div>
            </div>

            <div class="w-full flex flex-wrap justify-around">
              <div v-for="id in options" :key="id">
                <div
                  class="w-[280px] flex flex-col rounded-[24px] bg-black p-6 border-sky-500 border-4 mb-16"
                >
                  <img
                    :src="id.image"
                    alt=""
                    class="w-full aspect-square rounded-[12px] object-cover mb-3"
                  />
                  <h4 class="text-white mb-0 text-center">{{ id.name }}</h4>
                  <div
                    class="w-full h-[2px] rounded-lg bg-gray-800 mt-3 mb-3"
                  />
                  <div class="flex justify-between text-sm font-medium">
                    <span class="text-neon">{{ id.cut }} CUT</span>
                    <span class="text-sky-500"
                      >{{ id.spotsTaken }} / {{ id.max }} Spots filled</span
                    >
                  </div>
                  <div
                    class="mt-3 bg-gray-15 w-full h-[48px] font-medium flex justify-center items-center rounded-[10px] text-white-64"
                  >
                    <span
                      v-if="id.hours > 0 || id.minutes > 0 || id.seconds > 0"
                      >{{ id.hours }}:{{ id.minutes }}:{{
                        id.seconds
                      }}
                      Left</span
                    >
                    <span
                      v-if="id.hours == 0 && id.minutes == 0 && id.seconds == 0"
                      >Ended</span
                    >
                  </div>
                  <input
                    class="mt-3 bg-white font-medium rounded-[10px] h-[48px] flex justify-center items-center text-center"
                    type="text"
                    v-if="
                      id.shouldBeEnabled && id.spotsTaken < id.max && !id.owned
                    "
                    v-model="discordInput"
                    placeholder="Discord Name + ID"
                  />
                  <input
                    class="mt-3 bg-gray-15 font-medium text-white-64 rounded-[10px] h-[48px] flex justify-center items-center text-center"
                    type="text"
                    v-if="
                      !id.shouldBeEnabled || id.spotsTaken >= id.max || id.owned
                    "
                    disabled
                    placeholder="Discord Name + ID"
                  />
                  <div class="flex mt-3">
                    <a
                      class="linkTwitter mr-3"
                      :href="id.twitter"
                      target="_blank"
                      ><img
                        class="twitterImg mr-4"
                        src="../../assets/twitter.png"
                        alt=""
                    /></a>
                    <div
                      v-if="!loadingTransaction && !id.notOwned"
                      class="w-full"
                    >
                      <button
                        v-if="
                          id.shouldBeEnabled &&
                            id.spotsTaken < id.max &&
                            !id.owned
                        "
                        class="w-full h-[48px] bg-sky-500 text-white rounded-[10px] font-medium"
                        @click="addToDB(id)"
                      >
                        PURCHASE
                      </button>
                      <button
                        v-if="id.owned && id.shouldBeEnabled"
                        class="w-full h-[48px] bg-gray-32 text-white-64 rounded-[10px] font-medium"
                        disabled
                      >
                        Owned
                      </button>
                      <button
                        v-if="
                          (!id.shouldBeEnabled || id.spotsTaken >= id.max) &&
                            !loadingTransaction
                        "
                        class="w-full h-[48px] bg-gray-32 text-white-64 rounded-[10px] font-medium"
                        disabled
                      >
                        SOLD OUT
                      </button>
                      <b-icon
                        v-if="loadingTransaction"
                        icon="arrow-clockwise"
                        animation="spin"
                        class="text-white"
                        font-scale="3"
                      ></b-icon>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="w-[280px] flex flex-col rounded-[24px] bg-black p-6 border-sky-500 border-4 mb-16"
                v-for="id in raffle"
                :key="id"
              >
                <img
                  :src="id.image"
                  alt=""
                  class="w-full aspect-square rounded-[12px] object-cover mb-3"
                />
                <h4 class="text-white mb-0  text-center">
                  {{ id.name }}<span class="smallText text-sm"> (Raffle)</span>
                </h4>
                <div class="w-full h-[2px] rounded-lg bg-gray-800 mt-3 mb-3" />
                <div class="flex justify-between text-sm font-medium">
                  <span class="text-neon"
                    >{{ id.price * raffleEntries }} CUT</span
                  >
                  <span class="text-sky-500"> {{ id.entries }} Entrie(s)</span>
                </div>
                <div
                  class="mt-3 bg-gray-15 w-full h-[48px] font-medium flex justify-center items-center rounded-[10px] text-white-64"
                >
                  <span
                    v-if="
                      options[1].hours > 0 || id.minutes > 0 || id.seconds > 0
                    "
                    >{{ id.hours }}:{{ id.minutes }}:{{ id.seconds }} Left</span
                  >
                  <span
                    v-if="id.hours == 0 && id.minutes == 0 && id.seconds == 0"
                    >Ended</span
                  >
                </div>
                <input
                  class="mt-3 bg-white font-medium rounded-[10px] h-[48px] flex justify-center items-center text-center"
                  type="text"
                  v-if="id.shouldBeEnabled"
                  v-model="discordInput"
                  placeholder="Discord name + ID"
                />
                <input
                  class="mt-3 bg-gray-15 font-medium text-white-64 rounded-[10px] h-[48px] flex justify-center items-center text-center"
                  type="text"
                  v-if="!id.shouldBeEnabled"
                  v-model="discordInput"
                  placeholder="Discord name + ID"
                  disabled
                />
                <input
                  class="mt-3 bg-white font-medium rounded-[10px] h-[48px] flex justify-center items-center text-center"
                  type="number"
                  min="1"
                  v-if="id.shouldBeEnabled"
                  v-model="raffleEntries"
                  placeholder="Amount Of Entries"
                />
                <div class="flex w-full mt-3" v-if="!loadingTransaction">
                  <button
                    class="w-full h-[48px] bg-sky-500 text-white rounded-[10px] font-medium"
                    @click="addToDBRaffle(id.name, id.price, id.entryInfo)"
                    v-if="id.shouldBeEnabled"
                  >
                    ENTER
                  </button>
                  <button
                    v-if="!id.shouldBeEnabled"
                    class="w-full h-[48px] bg-gray-32 text-white-64 rounded-[10px] font-medium"
                    disabled
                  >
                    FINISHED
                  </button>
                </div>
                <b-icon
                  v-if="loadingTransaction"
                  icon="arrow-clockwise"
                  animation="spin"
                  class="text-white mt-3"
                  font-scale="3"
                ></b-icon>
              </div>

              <div
                class="w-[280px] flex flex-col rounded-[24px] bg-black p-6 border-sky-500 border-4 mb-16"
              >
                <img
                  src="../../assets/ShopArt/shirt.jpg"
                  alt=""
                  class="w-full aspect-square rounded-[12px] object-cover mb-3"
                />
                <h4 class="text-white mb-0 text-center">
                  Shirt Coupon
                  <span class="smallText text-sm">(Shipping not included)</span>
                </h4>
                <div class="w-full h-[2px] rounded-lg bg-gray-800 mt-3 mb-3" />
                <h6 class="spotsLeftSpan">
                  <span class="cutSpanRaffle text-xl mb-0">500 CUT</span>
                </h6>

                <input
                  class="mt-3 bg-white font-medium rounded-[10px] h-[48px] flex justify-center items-center text-center"
                  type="text"
                  v-model="discordInput"
                  placeholder="Discord name + ID"
                />
                <div v-if="!loadingTransaction" class="w-full mt-3">
                  <button
                    class="w-full h-[48px] bg-sky-500 text-white rounded-[10px] font-medium"
                    @click="addToDBShirt()"
                  >
                    PURCHASE
                  </button>
                </div>
                <b-icon
                  v-if="loadingTransaction"
                  icon="arrow-clockwise"
                  animation="spin"
                  font-scale="3"
                ></b-icon>
              </div>
            </div>
            <div
              class="w-full bg-gray-800 rounded-[24px] flex flex-col gap-4 lg:flex-row justify-between px-8 py-6 md:px-12 md:py-10 mb-16 border-sky-500 border-4"
            >
              <span class="text-4xl text-white font-medium"
                >Search Purchase History</span
              >
              <div
                class="flex justify-center rounded-[12px] text-lg md:text-2xl px-1 font-medium"
              >
                <input
                  class="mt-3 bg-gray-15 font-medium text-white-64 rounded-[10px] h-[48px] flex justify-center items-center text-center"
                  type="text"
                  v-model="discordSearch"
                  placeholder="Discord Name + ID"
                />
                <button
                  @click="popModal()"
                  class="w-full h-[48px] text-white rounded-[10px] font-medium searchButton"
                >
                  SEARCH
                </button>
              </div>
            </div>

            <b-modal
              size="lg"
              ref="enteredList"
              hide-footer
              title="Projects You Entered"
            >
              <div
                class="d-block text-center"
                v-for="entered in projectsEntered"
                :key="entered"
              >
                <h3>{{ entered.proj }} - {{ entered.date }}</h3>
                <br />
              </div>
            </b-modal>

            <b-modal
              size="lg"
              ref="entryInformation"
              hide-footer
              title="Details To Enter"
            >
              <div class="d-block text-center">
                <h3 style="white-space: pre-line">{{ winnerInfo }}</h3>
                <br />
              </div>
            </b-modal>
          </div>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Web3 from "web3";
import axios from "axios";
import tokenContractInfo from "../../assets/contracts/newCut.json";

import cosmicVX from "../../assets/whitelistImages/vxWL.png";

export default {
  data: function() {
    return {
      discordInput: "",
      selected: null,
      selectedMax: 0,
      selectedCut: 0,
      winnerInfo: "",
      options: [
        {
          id: 0,
          owned: false,
          name: "TAT (Twelve Anonymous Tournaments) ",
          cut: 50,
          image: "https://media.discordapp.net/attachments/1013822207551615077/1014147933890949210/TAT_gif_test1.gif",
          max: 12,
          spotsTaken: 0,
          twitter: "https://twitter.com/tat_nftgame",
          shouldBeEnabled: true,
          unixTime: 1664298000,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          entryInfo: "Information Handover Date: September 27\n\nInformation Submitted: Wallet Addresses & Discord IDs\n\nWill Roles Be Assigned: No\n\nWallet Submission Needed: No\n\nAddresses will be DTC"
        },
        {
          id: 1,
          owned: false,
          name: "Beefy Blokes",
          cut: 20,
          image: "https://pbs.twimg.com/media/FcIk0JFacAM4K_9?format=jpg&name=small",
          max: 15,
          spotsTaken: 0,
          twitter: "https://twitter.com/BeefyBlokes",
          shouldBeEnabled: true,
          unixTime: 1664384400,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          entryInfo: "Information Handover Date: September 28\n\nInformation Submitted: Wallet Addresses & Discord IDs\n\nWill Roles Be Assigned: No\n\nWallet Submission Needed: No\n\nAddresses will be DTC"
        },

      ],
      raffle: [
      ],

      web3: "",

      tokenContract: "",
      tokenContractAbi: tokenContractInfo.abi,
      tokenContractAddress: tokenContractInfo.contractAddress,

      alreadyInDB: false,
      amountInDB: 0,

      walletAddress: "",
      walletBalance: "",
      tokenAmount: 0,
      discordInput: "",

      databaseID: "",
      databaseIDCUT: "",
      raffleEntries: 1,

      loadingTransaction: false,

      discordSearch: "",
      totalDBList: [],

      projectsEntered: []
    };
  },
  mounted() {
    this.LoadEthWallet();
    this.checkAll();
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    async gatherInformation() {
      await axios
        .get("https://my-app-2-9xqlr.ondigitalocean.app/api/contacts")
        .then(response => {
          for (var i = 0; i < response.data.data.length; i++) {
            if (response.data.data[i].address === this.walletAddress) {
              this.databaseIDCUT = response.data.data[i]._id;
              this.tokenAmount = Number(response.data.data[i].cutAmount);
            }
          }
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        })
        .then(function() {
          // always executed
        });
    },
    async updateDBBalance() {
      await axios
        .put(
          `https://my-app-2-9xqlr.ondigitalocean.app/api/contacts/${this.databaseIDCUT}`,
          {
            address: this.walletAddress,
            cutAmount: this.tokenAmount.toString()
          }
        )
        .then(response => {})
        .catch(function(error) {
          // handle error
          console.log(error);
        })
        .then(function() {
          // always executed
        });
      this.gatherInformation();
    },
    popModal() {
      const regex = new RegExp("^.{2,32}#[0-9]{4}$");

      if (regex.test(this.discordSearch)) {
        this.projectsEntered = [];
        for (var i = 0; i < this.totalDBList.length; i++) {
          if (this.totalDBList[i].discordName === this.discordSearch) {
            var options = {
              proj: this.totalDBList[i].whiteListChoice,
              date: this.totalDBList[i].date.substring(0, 10)
            };
            this.projectsEntered.push(options);
          }
        }
        this.$refs["enteredList"].show();
      } else {
        alert("Incorrect Discord Format!");
      }
    },
    async checkIfBought() {
      await axios
        .get(`https://cosmiclabsapi.herokuapp.com/api/contacts`)
        .then(response => {
          for (var i = 0; i < response.data.data.length; i++) {
            for (var x = 0; x < this.options.length; x++) {
              if (
                response.data.data[i].whiteListChoice ===
                  this.options[x].name &&
                response.data.data[i].address === this.walletAddress
              ) {
                this.options[x].owned = true;
              }
            }
          }
        })
        .catch(err => {
          this.loadingTransaction = false;
        });
    },
    async checkAll() {
      for (var i = 0; i < this.raffle.length; i++) {
        this.raffle[i].entries = 0;
      }

      for (var i = 0; i < this.options.length; i++) {
        this.options[i].spotsTaken = 0;
      }

      await axios
        .get(`https://cosmiclabsapi.herokuapp.com/api/contacts`)
        .then(response => {
          this.totalDBList = response.data.data;
          for (var i = 0; i < response.data.data.length; i++) {
            for (var x = 0; x < this.options.length; x++) {
              if (
                response.data.data[i].whiteListChoice == this.options[x].name
              ) {
                this.options[x].spotsTaken++;
              }
            }
            for (var z = 0; z < this.raffle.length; z++) {
              if (
                response.data.data[i].whiteListChoice == this.raffle[z].name
              ) {
                this.raffle[z].entries += 1;
              }
            }
          }
        })
        .catch(err => {
          this.loadingTransaction = false;
        });
    },
    async checkIfInDB() {
      this.loadingTransaction = true;
      this.alreadyInDB = false;
      await axios
        .get(`https://cosmiclabsapi.herokuapp.com/api/contacts`)
        .then(response => {
          for (var i = 0; i < response.data.data.length; i++) {
            if (
              (response.data.data[i].address == this.walletAddress ||
                response.data.data[i].discordName == this.discordInput) &&
              response.data.data[i].whiteListChoice == this.selected
            ) {
              this.alreadyInDB = true;
            }
          }
        })
        .catch(err => {
          this.loadingTransaction = false;
        });
    },
    async checkAmountDB() {
      this.loadingTransaction = true;

      await axios
        .get(`https://cosmiclabsapi.herokuapp.com/api/contacts`)
        .then(response => {
          for (var i = 0; i < response.data.data.length; i++) {
            if (response.data.data[i].whiteListChoice == this.selected) {
              this.amountInDB += 1;
            }
          }
        })
        .catch(err => {
          this.loadingTransaction = false;
        });
    },
    async callDB(number) {
      if (number === undefined) {
        number = 1;
      }

      for (var i = 0; i < number; i++) {
        await axios
          .post(`https://cosmiclabsapi.herokuapp.com/api/contacts`, {
            address: this.walletAddress,
            discordName: this.discordInput,
            whiteListChoice: this.selected
          })
          .then(response => {
            console.log(response);
            this.databaseID = response.data.data._id;
          })
          .catch(err => {
            this.loadingTransaction = false;
          });
      }
    },
    async burnTokens(selection) {
      this.loadingTransaction = false;
      this.$refs["entryInformation"].show();
      this.checkAll();
      this.checkIfBought();
      this.tokenAmount -= Number(this.selectedCut);
      this.updateDBBalance();
    },
    async removeFromDB() {
      await axios
        .delete(
          `https://cosmiclabsapi.herokuapp.com/api/contacts/${this.databaseID}`
        )
        .then(response => {})
        .catch(err => {
          console.log(err);
          this.loadingTransaction = false;
        });
    },
    async addToDBShirt() {
      this.selectedCut = 500;
      this.selected = "Shirt Coupon";
      const regex = new RegExp("^.{2,32}#[0-9]{4}$");

      if (Number(this.tokenAmount) >= this.selectedCut) {
        if (regex.test(this.discordInput)) {
          this.loadingTransaction = true;
          this.callDB().then(res => {
            this.burnTokens(this.selected);
          });
        } else {
          alert("Incorrect discord format.");
        }
      } else {
        alert("You don't have enough CUT");
      }
    },
    async addToDBRaffle(name, amount, info) {
      this.selectedCut = amount * this.raffleEntries;
      this.selected = name;
      this.winnerInfo = info;

      const regex = new RegExp("^.{2,32}#[0-9]{4}$");
      if (Number(this.tokenAmount) >= this.selectedCut) {
        if (regex.test(this.discordInput)) {
          this.loadingTransaction = true;
          this.callDB(this.raffleEntries).then(res => {
            this.burnTokens(this.selected);
          });
        } else {
          alert("Please enter the correct Discord Name including #");
        }
      } else {
        alert("You don't have enough CUT");
      }
    },
    async addToDB(selection) {
      const regex = new RegExp("^.{2,32}#[0-9]{4}$");

      if (regex.test(this.discordInput)) {
        this.selected = selection.name;
        this.selectedCut = selection.cut;
        this.selectedMax = selection.max;
        this.winnerInfo = selection.entryInfo;

        if (Number(this.tokenAmount) >= this.selectedCut) {
          this.checkIfInDB()
            .then(res => {
              if (this.alreadyInDB == false) {
                this.loadingTransaction = true;
                this.checkAmountDB()
                  .then(res => {
                    if (this.amountInDB < this.selectedMax) {
                      this.callDB().then(res => {
                        this.burnTokens(selection.name);
                      });
                    } else {
                      this.loadingTransaction = false;
                    }
                  })
                  .catch(err => {
                    console.log(err);
                    this.loadingTransaction = false;
                  });
              } else {
                this.loadingTransaction = false;
                alert(
                  "You are already whitelisted for " + selection.name + "!"
                );
              }
            })
            .catch(err => {
              console.log(err);
              this.loadingTransaction = false;
            });
        } else {
          alert("You don't have enough CUT");
        }
      } else {
        alert("Please enter the correct Discord Name including #");
      }
    },
    LoadTokenInfo: function() {
      this.tokenContract = new this.web3.eth.Contract(
        this.tokenContractAbi,
        this.tokenContractAddress
      );

      this.tokenContract.methods
        .balanceOf(this.walletAddress)
        .call({})
        .then(res => {
          this.tokenAmount = this.web3.utils.fromWei(res, "ether");
        });
    },
    async chainChange() {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x1" }] // chainId must be in hexadecimal numbers
      });
      this.LoadEthWallet();
    },
    LoadEthWallet: function() {
      if (typeof window.ethereum !== "undefined") {
        ethereum.enable();
        this.web3 = new Web3(
          this.walletConnect ||
            window.ethereum ||
            new Web3.providers.HttpProvider(
              "https://mainnet.infura.io/v3/1xVMLkEDl6htSmYN7YeFXGvIe07"
            ) ||
            Web3.givenProvider
        );
        this.web3.eth.net.getNetworkType().then(network => {
          if (network == "main") {
            this.web3.eth
              .requestAccounts()
              .then(acc => {
                this.walletAddress = acc[0];
                this.checkIfBought();

                this.web3.eth.getBalance(this.walletAddress).then(balance => {
                  this.walletBalance = this.web3.utils.fromWei(
                    balance,
                    "ether"
                  );
                  this.gatherInformation();
                });
              })
              .catch(err => {
                console.log(err);
              });
          } else {
            this.chainChange();
          }
        });
      }
    }
  },
  computed: {
    reversedMessage: function() {
      var globalClock = this;

      var countDownDate = new Date(this.options[0].unixTime * 1000).getTime();
      setInterval(
        function() {
          var now = new Date().getTime();
          var timeleft = countDownDate - now;
          var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
          var hours = Math.floor(
            (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          hours = hours + days * 24;
          if (hours < 10) {
            globalClock.options[0].hours = "0" + hours;
          } else globalClock.options[0].hours = hours;
          if (hours < 0) globalClock.options[0].hours = 0;
          var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
          if (minutes < 10) {
            globalClock.options[0].minutes = "0" + minutes;
          } else globalClock.options[0].minutes = minutes;
          if (minutes < 0) globalClock.options[0].minutes = 0;
          var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
          if (seconds < 10) {
            globalClock.options[0].seconds = "0" + seconds;
          } else globalClock.options[0].seconds = seconds;
          if (seconds < 0) globalClock.options[0].seconds = 0;
          if (countDownDate - now > 0) {
            globalClock.options[0].shouldBeEnabled = true;
          } else globalClock.options[0].shouldBeEnabled = false;
        },
        1000,
        this
      );

            var countDownDate2 = new Date(this.options[1].unixTime * 1000).getTime();
      setInterval(
        function() {
          var now = new Date().getTime();
          var timeleft = countDownDate2 - now;
          var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
          var hours = Math.floor(
            (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          hours = hours + days * 24;
          if (hours < 10) {
            globalClock.options[1].hours = "0" + hours;
          } else globalClock.options[1].hours = hours;
          if (hours < 0) globalClock.options[1].hours = 0;
          var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
          if (minutes < 10) {
            globalClock.options[1].minutes = "0" + minutes;
          } else globalClock.options[1].minutes = minutes;
          if (minutes < 0) globalClock.options[1].minutes = 0;
          var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
          if (seconds < 10) {
            globalClock.options[1].seconds = "0" + seconds;
          } else globalClock.options[1].seconds = seconds;
          if (seconds < 0) globalClock.options[1].seconds = 0;
          if (countDownDate2 - now > 0) {
            globalClock.options[1].shouldBeEnabled = true;
          } else globalClock.options[1].shouldBeEnabled = false;
        },
        1000,
        this
      );
  }
  }
};
</script>

<style scoped>
.searchButton {
  margin-top: 1.5vh;
  margin-left: 1vh;
}

.bg-black-80 {
  background-color: rgba(0, 0, 0, 0.65);
}
.bg-gray-15 {
  background-color: rgba(255, 255, 255, 0.15);
}
.bg-gray-32 {
  background-color: rgba(255, 255, 255, 0.32);
}
.text-white-64 {
  color: rgba(255, 255, 255, 0.64);
}
.text-neon {
  color: #10ecff;
}
.smallText {
  color: #f8ff00;
}
.highlight {
  color: #f8ff00;
}
.whiteToken {
  color: #10ecff;
}
.cutSpanRaffle {
  color: #10ecff;
}
@keyframes anim {
  from {
    text-shadow: 0 0 10px transparent;
  }
  to {
    text-shadow: 0 28px 50px rgba(0, 0, 0, 0.8);
  }
}

.spotsLeftSpan {
  color: #2b92f0;
  font-size: 14px;
}

.backgroundWhiteList {
  background: url("../../assets/whitelistImages/desktop.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.backgroundWhiteListMobile {
  background: url("../../assets/whitelistImages/mobile.png");
  background-repeat: no-repeat;
  background-size: contain;
}

.content {
  margin-top: 80vh;
}

@media only screen and (max-width: 1399px) {
  .backgroundWhiteList {
    background-size: contain;
  }
  .content {
    margin-top: 60vh;
  }
}
.twitterImg {
  border-radius: 10px;
  width: 48px;
  height: 48px;
  display: inline-block;
  line-height: 40px;
}
.linkTwitter {
  display: inline-block;
  line-height: 40px;
}
.cantSee {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Store/whiteList.vue